import React from 'react';

import { MultipleFieldsListFormFieldItem } from '@/components/molecules/MultipleFieldsListFormFieldItem';
import { SingleFieldListFormFieldItem } from '@/components/molecules/SingleFieldListFormFieldItem';
import { Field } from '@/types/fields';
import { Identified } from '@/types/identified';

interface Props {
  readonly defaultItem: Identified<any>;
  readonly fields: ReadonlyArray<Field<any>>;
  readonly title: string | undefined;
  readonly counter: number;

  onRemove(item: Identified<any>): void;
  onChange(item: Identified<any>): void;
}

export const ListFormFieldItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { counter, defaultItem, fields, title, onRemove, onChange } = props;

  if (fields.length === 1) {
    return (
      <SingleFieldListFormFieldItem
        field={fields[0]}
        item={defaultItem}
        counter={counter}
        title={title}
        onChange={onChange}
        onRemove={onRemove}
      />
    );
  } else {
    return (
      <MultipleFieldsListFormFieldItem
        fields={fields}
        defaultItem={defaultItem}
        counter={counter}
        title={title}
        onChange={onChange}
        onRemove={onRemove}
      />
    );
  }
};
